module.exports = __webpack_public_path__ + "static/media/icon_invoice.df172049.svg";